module.exports = __webpack_public_path__ + "assets/images/template/project/animals/bat.png?v=12096efb";